import React, { useState } from "react";
import { useEffect } from "react";
import BoxSizeSelect from "./Warehouse/BoxSizeSelect";
interface BoxDimensionsProps {
  packageDimensions: {
    length: number;
    width: number;
    height: number;
    weight: number;
  };
  setPackageDimensions: React.Dispatch<
    React.SetStateAction<{
      length: number;
      width: number;
      height: number;
      weight: number;
    }>
  >;
  packageDimensionError: string;
  setPackageDimensionError: React.Dispatch<React.SetStateAction<string>>;
}

const BoxDimensions: React.FC<BoxDimensionsProps> = ({
  packageDimensions,
  setPackageDimensions,
  packageDimensionError,
  setPackageDimensionError,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPackageDimensions((prev) => ({
      ...prev,
      [name]: parseFloat(value),
    }));
  };

  const validatePackageDimensions = () => {
    let errors = [];

    if (packageDimensions.weight <= 0)
      errors.push("Weight must be greater than 0.");
    if (packageDimensions.length <= 0)
      errors.push("Length must be greater than 0.");
    if (packageDimensions.width <= 0)
      errors.push("Width must be greater than 0.");
    if (packageDimensions.height <= 0)
      errors.push("Height must be greater than 0.");

    setPackageDimensionError(errors.join(" "));
  };

  return (
    <div>
      <h3>Package Dimensions</h3>
      <BoxSizeSelect setPackageDimensions={setPackageDimensions} />
      <label>
        Length (in):
        <input
          className="shipping-ui-input"
          type="number"
          name="length"
          value={packageDimensions.length}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Width (in):
        <input
          className="shipping-ui-input"
          type="number"
          name="width"
          value={packageDimensions.width}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Height (in):
        <input
          className="shipping-ui-input"
          type="number"
          name="height"
          value={packageDimensions.height}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Weight (lb):
        <input
          className="shipping-ui-input"
          type="number"
          name="weight"
          value={packageDimensions.weight}
          onChange={handleInputChange}
        />
      </label>
      {packageDimensionError && (
        <div className="shipping-ui-error">{packageDimensionError}</div>
      )}
    </div>
  );
};

export default BoxDimensions;
